/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { httpService } from "../../../../services";
import { HTTP_METHOD } from "@nf/constants";
import { IDeviceListModel, IPlayDeviceModel } from "../models";

export class UserDevicesServices {
  get url(): string {
    return `/v2/device`;
  }

  public get = (): Promise<IDeviceListModel> =>
    httpService.request<IDeviceListModel>({
      method: HTTP_METHOD.GET,
      url: `${this.url}`,
    });

  public delete = (id: string): Promise<void> =>
    httpService.request<void>({
      method: HTTP_METHOD.DELETE,
      url: `${this.url}/${id}`,
    });

  public getPlayDevice = (): Promise<IPlayDeviceModel[]> =>
    httpService.request<IPlayDeviceModel[]>({
      method: HTTP_METHOD.GET,
      url: `/v1/play/device`,
    });

  public deletePlayDevice = (id: string): Promise<void> =>
    httpService.request<void>({
      method: HTTP_METHOD.DELETE,
      url: `/v1/play/device/${id}`,
    });
}
